/**
 * What the Dashboard's State column says for a capability row.
 *
 * "live" means different things per capability, and the copy says so (see LIVENESS_COPY): the
 * native-store capabilities are live on their per-tenant store; observability is live only when its
 * backend is configured AND answered a health check at boot. A not-live observability row says
 * "not live" and carries the integration's own description as its reason — never the generic
 * "planned" (which means a vendor seam awaiting the credential vault).
 */
export interface LivenessCapability { id: string; live: boolean }
export interface LivenessIntegration { port: string; adapter: string; live: boolean }
export interface RowState { label: "live" | "planned" | "not live"; reason?: string }

export const LIVENESS_COPY =
  'Each is a port with a working native adapter (per-tenant RLS store) and a vendor seam. "live" means ' +
  "the capability is on its native store (observability: a backend is configured and answered a health " +
  'check at boot); "planned" means routed at a vendor seam still awaiting the credential vault; ' +
  '"not live" (observability) shows why — no backend configured, or it did not answer at boot. Open one to use it.';

export function rowState(c: LivenessCapability, integrations: LivenessIntegration[]): RowState {
  if (c.live) return { label: "live" };
  if (c.id === "observability") {
    const i = integrations.find((x) => x.port === "observability");
    return { label: "not live", reason: i?.adapter ?? "no backend reported" };
  }
  return { label: "planned" };
}
